import React from "react";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import ManagementTeam from "@/components/ManagementTeam";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import ConsultationForm from "@/components/ConsultationForm";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Navbar />
        <Hero />
        <About />
        <ManagementTeam />
        <Services />
        <WhyUs />
        <ConsultationForm />
        <Contact />
        <Footer />
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
